const maxInt = 2147483647;
const intRegex = new RegExp('^-?\\d+$');

export function toInt(value: string | number, minValue?: number, maxValue?: number): number | null {
  if (minValue === undefined)
    minValue = 0;
  if (maxValue === undefined)
    maxValue = maxInt;

  switch (typeof value) {
    case 'string': {
      if (!intRegex.test(value))
        return null;
      let result = parseInt(value, 10);
      if (isNaN(result))
        return null;
      if (Number.isSafeInteger(result) &&
        result <= maxValue && result >= minValue)
        return result;
      return null;
    }
    case 'number': {
      if (Number.isSafeInteger(value) && value <= maxValue && value >= minValue)
        return value;
      return null;
    }
    default:
      return null;

  }
}

export function isInt(value: string | number, minValue?: number, maxValue?: number): boolean {
  return toInt(value, minValue, maxValue) !== null;
}
